import { render, staticRenderFns } from "./AddStringLoggersPage.vue?vue&type=template&id=b58a5868&scoped=true&"
import script from "./AddStringLoggersPage.vue?vue&type=script&lang=ts&"
export * from "./AddStringLoggersPage.vue?vue&type=script&lang=ts&"
import style0 from "./AddStringLoggersPage.vue?vue&type=style&index=0&id=b58a5868&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58a5868",
  null
  
)

export default component.exports